import {
  // MessageConfirmation,
  OutcomeWebsocketMessage
} from "@/types/websocketMessages/outcomeMessages";
import { Store } from "vuex";
import { DARStore } from "@/types/store";
import { Lot } from "../../../types/types";
import { uuidv4 } from "@/helpers/uuid";
import {
  getInitialData,
  getStoredToken
} from "@/store/plugins/websocket/createConnection";
// import { sendWebsocketMessage } from "@/store/plugins/websocket/sendOutgoingMessages";

export const handleIncomingMessages = (
  msg: OutcomeWebsocketMessage,
  store: Store<DARStore>
) => {
  const updateLot = (l: Lot) => {
    const lot = store.getters.lot(l.number);
    const newLot = {
      ...lot,
      ...l
    };
    store.commit("addLot", newLot);
  };
  // Send Reply
  // if (msg.type !== "messageReceived") {
  //   const reply: MessageConfirmation = {
  //     id: "",
  //     type: "messageReceived",
  //   };
  //   sendWebsocketMessage(reply);
  // }
  if (msg.status === 400 ) {
    store.commit("addSystemNotification", {
      id: '',
      message: msg.response,
      timestamp: new Date()
    });
  }

  if (msg.timeSent) {
    if (
      !store.state.lastMessageTime ||
      store.state.lastMessageTime < msg.timeSent
    ) {
      store.commit("setLastMessageTime", msg.timeSent);
    } else {
      // Old msg, do not process
      return;
    }
  }
  // Dispatch action
  switch (msg.type) {
    case "pong": {
      const ping = new Date().getTime() - store.state.lastPingTime;
      store.commit("setPing", ping / 2);
      break;
    }
    case "showLot": {
      window.parent.postMessage(
          {type: "selectLot", lotNumber: msg.lot.number},
          "*"
      );
      store.dispatch("selectLot", msg.lot.number);
      const lot = store.getters.lot(msg.lot.number);
      const newLot = {
        ...lot,
        ...msg.lot
      };
      store.commit("addLot", newLot);
      const sale = store.getters.sale;
      sale.resolvedLotsCount = msg.resolvedLotsCount;
      sale.isFinished = false;
      store.commit("setupSale", sale);
      break;
    }
    case "addOnlineInterest": {
      store.dispatch("addOnlineInterest", msg);
      break;
    }
    case "removeOnlineInterest": {
      store.dispatch("removeOnlineInterest", msg);
      break;
    }
    case "setBidderCount": {
      store.dispatch("setBidderCount", msg);
      break;
    }
    case "newBid": {
      if (!store.state.isMuted && msg.lot.bids?.[0].type === "online") {
        store.commit(
            "setOnlineBidNotificationCounter",
            store.state.onlineBidNotificationCounter + 1
        );
      }
      updateLot(msg.lot);
      break;
    }
    case "resolveLot": {
      updateLot(msg.lot);
      const sale = store.getters.sale;
      sale.resolvedLotsCount = msg.resolvedLotsCount;
      store.commit("setupSale", sale);
      break;
    }
    case "setManualIncrement":
    case "fairWarning":
    case "undoBid":
    case "setAsking":
    case "updateLot":
    case "resetLot": {
      updateLot(msg.lot);
      break;
    }
    case "setPause": {
      const sale = store.getters.sale;
      sale.pause = msg.pause;
      store.commit("setupSale", sale);
      break;
    }
    case "finishAuction": {
      const sale = store.getters.sale;
      sale.isFinished = msg.isFinished;
      sale.isAuctionClosed = msg.isAuctionClosed;
      store.commit("setupSale", sale);
      break;
    }
    case "broadcastMessage": {
      console.log(msg);
      if (msg.isAlert) {
        window.parent.postMessage({type: "alert", body: msg.content}, "*");
      } else {
        store.commit("setBroadcastMessage", {
          id: uuidv4(),
          message: msg.content,
          timestamp: new Date()
        });
      }
      break;
    }
    case "setManualIncrementList": {
      store.commit("setBidIncrements", [
        store.getters.bidIncrements,
        msg.steps
      ]);
      break;
    }
    case "setBroadcastMessages": {
      store.commit("setBroadcastMessages", msg.broadcastMessages);
      break;
    }
    case "streamStatus": {
      store.commit("setStreamStatus", msg.isStreaming);
      break;
    }
    case "saleInit": {
      const clientToken: string | null = getStoredToken();
      if (clientToken) {
        getInitialData(clientToken).then(data => {
          store.dispatch("initialSetup", data);
        });
      }
      break;
    }
    case "streamServiceStatus": {
      store.commit("setStreamServiceReady", msg.isReady);
      break;
    }
    case "startAuction": {
      const sale = store.getters.sale;
      sale.isStarted = true;
      store.commit("setupSale", sale);
      break;
    }
    case "systemMessage": {
      store.commit("addSystemNotification", {
        id: msg.id,
        message: msg.value,
        timestamp: new Date()
      });
      break;
    }
  }
};
